import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import Header from './header/';
import Menu from './menu';
import Content from './content';
import Cooperation from './cooperation';
import Footer from './footer';
import Affix from './affix';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const { docData, nav, menu, cooperation, footer, hasCopyRight, sourceReason } = content;

        const headerData = {
            nav,
        };

        return (
            <React.Fragment>
                <Header content={headerData} />
                <Chip id="30085" type="struct" title="头部目录" groupName="头部目录" content={menu}>
                    <Menu content={menu} />
                </Chip>
                <Content content={docData} hasCopyRight={hasCopyRight} sourceReason={sourceReason} />
                <NoSSR>
                    <Chip id="25010" type="static" title="底部合作链接" groupName="底部合作链接" content={cooperation}>
                        <Cooperation />
                    </Chip>
                </NoSSR>
                <Footer content={footer} />
                <NoSSR>
                    <Affix />
                </NoSSR>
                <ChipEdit transform={transform} />
            </React.Fragment>
        );
    }
}

export default Layout;
